import cn from "classnames";
import type { ElementType } from "react";
import styles from "./Flex.module.css";
import type { FlexAlign, FlexDirection, FlexJustify, FlexProps } from "./types";

const justifyClasses: Record<FlexJustify, string> = {
    start: styles.justifyStart,
    center: styles.justifyCenter,
    end: styles.justifyEnd,
    between: styles.justifyBetween,
};

const alignClasses: Record<FlexAlign, string> = {
    start: styles.alignStart,
    center: styles.alignCenter,
    end: styles.alignEnd,
    stretch: styles.alignStretch,
    unset: styles.alignUnset,
    baseline: styles.alignBaseline,
};

const directionClasses: Record<FlexDirection, string> = {
    row: styles.directionRow,
    column: styles.directionColumn,
    columnReverse: styles.directionColumnReverse,
    rowReverse: styles.directionRowReverse,
};

const defaultElement: ElementType = "div";

export function Flex(props: FlexProps) {
    const {
        as,
        className,
        children,
        justify,
        align = "center",
        direction,
        wrap,
        gap,
        fullWidth,
        fullHeight,
        ...otherProps
    } = props;

    const TagName = as || defaultElement;

    const flexStyles = cn(
        styles.flex,
        fullWidth && styles.fullWidth,
        fullHeight && styles.fullHeight,
        justify && justifyClasses[justify],
        alignClasses[align],
        direction && directionClasses[direction],
        wrap && styles[wrap],
        className,
    );

    let gapSize = gap;
    if (typeof gapSize === "number") {
        gapSize = `${gapSize}px`;
    }

    const flexInlineStyles = {
        ...otherProps.style,
        gap: gapSize,
    };

    return (
        <TagName className={flexStyles} {...otherProps} style={flexInlineStyles}>
            {children}
        </TagName>
    );
}
